import PositionDto from '$types/serverTypes/positionDto';
import { CompanyBuilder } from '../companies.types';

export const savePositionEnhanced = (builder: CompanyBuilder) =>
  builder.mutation<PositionDto, FormData>({
    query: (payload) => ({
      url: '/positions/enhanced',
      method: 'POST',
      body: payload,
    }),
  });
